function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  fill: "currentColor",
  cx: 316,
  cy: 414.5,
  r: 7.5
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  fill: "currentColor",
  cx: 181,
  cy: 172.5,
  r: 7.5
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  fill: "currentColor",
  cx: 211,
  cy: 202.5,
  r: 7.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M411.488 77.389A7.497 7.497 0 00406 75H278.5V52.5c0-4.136 3.364-7.5 7.5-7.5h75a7.5 7.5 0 007.5-7.5v-30A7.5 7.5 0 00361 0h-75c-28.949 0-52.5 23.552-52.5 52.5V75H106a7.5 7.5 0 00-7.481 8.033l28.019 394.127c1.388 19.536 17.818 34.84 37.405 34.84h184.114c19.586 0 36.017-15.304 37.405-34.841l28.019-394.127a7.495 7.495 0 00-1.993-5.643zM367.872 90l-3.199 45H278.5V90zM241 432h30a7.5 7.5 0 007.5-7.5V150h85.106l-22.523 316.826c-16.897-.876-26.24-4.936-36.066-9.205C293 452.399 280.573 447 256 447s-37 5.399-49.017 10.621c-9.826 4.27-19.169 8.329-36.066 9.205L148.394 150H233.5v274.5a7.5 7.5 0 007.5 7.5zm7.5-15V150h15v267zm0-364.5c0-20.678 16.822-37.5 37.5-37.5h67.5v15H286c-12.407 0-22.5 10.094-22.5 22.5V75h-15zm15 37.5v45h-15v-22.5c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5V135h-86.173l-3.199-45zm107 386.095C369.667 487.817 359.809 497 348.057 497H163.943c-11.752 0-21.61-9.183-22.443-20.905L114.052 90h15.038l27.372 385.032a7.5 7.5 0 007.481 6.968c24.573 0 37-5.399 49.017-10.621C224.06 466.556 234.544 462 256 462s31.939 4.556 43.04 9.379C311.057 476.601 323.483 482 348.057 482a7.5 7.5 0 007.481-6.968L382.909 90h15.038z"
});

var SvgSoda = function SvgSoda(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSoda, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/soda.a2a3cc4e.svg";
export { ForwardRef as ReactComponent };